import * as types from '../actions/typeNames';
//import { findElementByPropName } from '../services/service'

const formList = (state = [], action) => {
    switch(action.type){
        case types.ADD_NEW_FORM:                    
            return [
                ...state,
                {
                    FormId: action.form.FormId,
                    Name: action.form.Name
                }
            ]
        case types.SAVE_SUCCESS:
            return state.map((form) => {
                if(form.FormId === action.form.FormId)
                    form.Name = action.form.Name
                return form
            })
        case types.EDIT_FORM:                    
            return [
                ...state,
                {
                    FormId: action.form.FormId,
                    Name: action.form.Name
                }
            ]
        case types.DELETE_FORM:
            return [...state.filter((form) => {
                return form.FormId !== action.id;
            })]
        case types.DUPLICATE_FORM:
                return [
                    ...state,
                    {
                        FormId: action.form.FormId,
                        Name: action.form.Name
                    }
                ]
        case types.GET_ALL_LIST:
            return action.forms || state; // at least sometimes there's no forms field
        default:
            return [...state];
    }
}

export default formList;